export enum HelpOverlayTypes {
  SetValues = 'HelpOverlay.SetValues',
}

export interface HelpForm {
  emailSubject: string;
  emailText: string;
}
